import React from 'react';

/** Layout-matching skeleton for chart panels. */
export default function ChartSkeleton({ heightClass = 'h-64' }) {
  return (
    <div className={`${heightClass} flex flex-col justify-end gap-2`} aria-hidden>
      <div className="flex flex-1 items-end gap-1.5 px-1">
        {[40, 65, 45, 80, 55, 70, 50, 85, 60, 75, 48, 68].map((h, i) => (
          <div
            key={i}
            className="flex-1 rounded-t bg-dark-surface animate-pulse"
            style={{ height: `${h}%` }}
          />
        ))}
      </div>
      <div className="h-2 w-1/3 rounded bg-dark-surface animate-pulse" />
    </div>
  );
}
